export function debouncePromise(func: (...params: any[]) => any, wait?: number) {
  let timer = null;
  let resolves = [];

  return (...args: any[]): Promise<ReturnType<typeof func>> => {
    clearTimeout(timer);

    timer = setTimeout(() => {
      const result = func(...args);
      resolves.forEach(resolve => resolve(result));
      resolves = [];
    }, wait ?? 0);

    return new Promise(resolve => resolves.push(resolve));
  };
}
